import React from 'react';
import { Row, Badge, Col } from 'antd';
import { Paragraph } from '@/components/Typography';
import type { Task } from '../types';
import * as S from './styles';

interface TaskItemProps {
	task: Task;
}

export function TaskItem({ task }: Readonly<TaskItemProps>) {
	return (
		<Row align="middle" justify="space-between">
			<Col span={1}>
				<Badge status="default" />
			</Col>
			<S.Description span={23}>
				<Paragraph>{task.description}</Paragraph>
			</S.Description>
		</Row>
	);
}
